// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"757":"af5a7a2e44a72f9c","4449":"d65ce920e50955e8"}[chunkId] + ".js";
};